import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const parametricDefinitionMap = new Map();

parametricDefinitionMap.set(KnowEdmTableData.Md, {
  key: KnowEdmTableData.Md,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'MD',
});

parametricDefinitionMap.set(KnowEdmTableData.Cl, {
  key: KnowEdmTableData.Cl,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'Cl',
});

parametricDefinitionMap.set(KnowEdmTableData.Inclination, {
  key: KnowEdmTableData.Inclination,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'INC',
});

parametricDefinitionMap.set(KnowEdmTableData.Azimuth, {
  key: KnowEdmTableData.Azimuth,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'AZI',
});

parametricDefinitionMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'TVD',
});

parametricDefinitionMap.set(KnowEdmTableData.Ew, {
  key: KnowEdmTableData.Ew,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'EW',
});

parametricDefinitionMap.set(KnowEdmTableData.Ns, {
  key: KnowEdmTableData.Ns,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
  label: 'NS',
});

parametricDefinitionMap.set(KnowEdmTableData.Vsec, {
  key: KnowEdmTableData.Vsec,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'V.sec',
});

parametricDefinitionMap.set(KnowEdmTableData.Dls, {
  key: KnowEdmTableData.Dls,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
  label: 'DLS',
});

parametricDefinitionMap.set(KnowEdmTableData.Tf, {
  key: KnowEdmTableData.Tf,
  unit: defaultUnits.get(QuantitiesTypes.Angle),
  quantity: QuantitiesTypes.Angle,
  label: 'TF',
});

parametricDefinitionMap.set(KnowEdmTableData.BuildRate, {
  key: KnowEdmTableData.BuildRate,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
  label: 'Build',
});

parametricDefinitionMap.set(KnowEdmTableData.TurnRate, {
  key: KnowEdmTableData.TurnRate,
  unit: defaultUnits.get(QuantitiesTypes.AngleGradient),
  quantity: QuantitiesTypes.AngleGradient,
  label: 'TurnRate',
});

export { parametricDefinitionMap };